import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import RSVP from 'rsvp';

class BusinessGoalsGoalInitiativesRoute extends Route {
  @service store;
  @service betaToggle;

  queryParams = {
    status: {
      refreshModel: false,
    },
    sources: {
      refreshModel: false,
    },
    productManagers: {
      refreshModel: false,
    },
    themes: {
      refreshModel: false,
    },
    teams: {
      refreshModel: false,
    },
    roadmaps: {
      refreshModel: false,
    },
    goals: {
      refreshModel: false,
    },
  };

  beforeModel() {
    const promises = [
      this.store.findAll('theme'),
      this.store.findAll('person'),
      this.store.findAll('team'),
      this.store.findAll('goal'),
      this.store.findAll('role'),
      this.store.findAll('roadmap'),
      this.store.findAll('investment-scenario'),
    ];
    return Promise.all(promises);
  }

  model(params) {
    const defaultStatus = this.betaToggle.statusOptions.map(
      (item) => item.value,
    );

    const _params = { ...params };
    delete _params['columns'];
    delete _params['grouping'];
    if (_params.status == undefined || _params.status.length === 0)
      _params.status = defaultStatus;
    return RSVP.hash({
      // initiatives: this.store.query('initiative', {
      //   ..._params,
      //   goals: [this.modelFor('business.goals.goal').id],
      //   include: 'workstream',
      // }),
      goal: this.modelFor('business.goals.goal'),
    });
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    if (!controller.get('sort')) {
      controller.set('sort', 'status');
    }

    if (controller.get('statuses').length === 0) {
      controller.set('statuses', this.defaultStatus);
    }

    if (!controller.get('grouping')) {
      controller.set('grouping', 'statuses');
    }

    if (controller.get('columns').length === 0) {
      const columns = controller.get('columnOptions').reduce((acc, item) => {
        if (item.show === undefined) acc.push(item.label);
        else if (item.show === true) acc.push(item.label);
        return acc;
      }, []);
      controller.set('columns', columns);
    }
    // controller.set('list', model.initiatives);
  }
}

export default instrumentRoutePerformance(BusinessGoalsGoalInitiativesRoute);
